import { HelmetProvider } from 'react-helmet-async';
import BrowserRouterComponents from './Router';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { API_RECALL, SET_SCANNING_MONITORING } from './Actions/Types';
import { useEffect, useRef } from 'react';
import { StoreProptypes } from './PropTypes/StoreProptypes';
import { getScanningMonitoringActivePlanStatus } from './Services/PlanListService';

// main component to render the app
function App() {

  const dispatch = useDispatch();
  const { currentWebsite, accessToken } = useSelector((store: StoreProptypes) => store);
  const lastDomain = useRef<string | null>(null);

  const helmetContext = {};

  // function to get cookies
  const setCookie = (
    name: string, // cookie name
    value: string // cookie value
  ) => {
    let inFifteenMinutes = new Date(new Date().getTime() + 60 * 60 * 1000);
    Cookies.set(name, value, { expires: inFifteenMinutes });
  };

  // function to get cookie value
  const getCookie = (
    name: string // cookie name
  ): string | undefined => {
    return Cookies.get(name);
  };

  // function to check if cookie is expired (returns true if expired)
  const isCookieExpired = (
    name: string // cookie name
  ): boolean => {
    const value = getCookie(name);
    return value === undefined;
  };

  // check if cookie is expired
  useEffect(() => {
    if (isCookieExpired("apiDataRecall")) {
      setCookie("apiDataRecall", "true");

      // Loading
      dispatch({
        type: API_RECALL,
        payload: true,
      });
    }
  }, [dispatch]);

  useEffect(() => {
    if (!currentWebsite?.domain || !accessToken) return;

    // only run when domain actually changes
    if (lastDomain.current === currentWebsite.domain) return;
    const setIsScanningMonitoring = (value: boolean) => {
      dispatch({
        type: SET_SCANNING_MONITORING,
        payload: {
          isScanningMonitoring: value,
          scanningMonitoringUrl:
            "https://staging.skynetaccessibilityscan.com/autologin/bXlyYS5jb20=",
        },
      });
    };

    const setscanningMonitoringUrl = (url: string) => {
      const isValid = typeof url === "string" && url.trim() !== "";

      dispatch({
        type: SET_SCANNING_MONITORING,
        payload: {
          isScanningMonitoring: isValid,
          scanningMonitoringUrl: isValid ? url : "",
        },
      });
    };

    getScanningMonitoringActivePlanStatus(
      accessToken,
      currentWebsite.domain,
      setIsScanningMonitoring,
      setscanningMonitoringUrl
    );

    lastDomain.current = currentWebsite.domain;

  }, [currentWebsite?.domain, accessToken]); // ✅ IMPORTANT
  return (
    <>
      <HelmetProvider context={helmetContext}>
        <BrowserRouterComponents />
      </HelmetProvider >
    </>
  );
}

export default App;
